'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors = {
  green1: '#35e65d',
  grey1: '#cdd8ec',
  grey2: '#f4f7f9',
  grey3: '#b5b5b5',
  turqois1: '#35cce6',
  turqois2: '#a3eaf7',
  white: '#fff',
  red: '#ff0000'
};

exports.colors = colors;
exports.default = {
  colors: colors
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chat-popup/lib/styles/variables.js
// module id = 47
// module chunks = 0